module.exports = __webpack_public_path__ + "static/media/maintenance.2fd7d235.svg";